import moment from 'moment'

export const conformanceType = {
  id: '',
  name: '',
  updatedAt : moment().format('YYYY-MM-DD'),
}